/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForAwsEksCluster extends models.ServiceAccountNativeDetailsBaseForKubernetesClusterCloud {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForAwsEksCluster");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForAwsEksCluster.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForAwsEksCluster>): ServiceAccountNativeDetailsForAwsEksCluster {
        let obj = Object.assign(new ServiceAccountNativeDetailsForAwsEksCluster(), model);
        ServiceAccountNativeDetailsForAwsEksCluster.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForAwsEksCluster>): ServiceAccountNativeDetailsForAwsEksCluster {
        if (!model) return null;
        return ServiceAccountNativeDetailsForAwsEksCluster.newInstance(<ServiceAccountNativeDetailsForAwsEksCluster> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForAwsEksCluster) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForAwsEksCluster.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForAwsEksCluster): boolean {
        if (models.ServiceAccountNativeDetailsBaseForKubernetesClusterCloud.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForAwsEksCluster.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
